import { render } from "./SingleCategory.vue?vue&type=template&id=9f511a9c"
import script from "./SingleCategory.vue?vue&type=script&lang=js"
export * from "./SingleCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/avandecorshop-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__